import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTRPCAPI } from '../../../../../trpc/trpc';
import { ArchivedPostFiles } from '../postsModel';

/** `assets.archived` (design assets-rethink c2): the archive of the artist, or of one song. */
export function useArchivedPosts(input: {
  accountId: number;
  catalogItemUuid: string | undefined;
  outcome: 'posted' | 'never' | undefined;
}): { archive: ArchivedPostFiles | undefined; isLoading: boolean; error: unknown; refetch: () => void } {
  const trpcAPI = useTRPCAPI();
  const query = useQuery(
    trpcAPI.assets.archived.queryOptions(
      {
        accountId: input.accountId,
        catalogItemUuid: input.catalogItemUuid ?? null,
        outcome: input.outcome ?? null,
      },
      { retry: false }
    )
  );
  const { refetch: refetchQuery } = query;
  const refetch = useCallback(() => {
    refetchQuery().catch(console.error);
  }, [refetchQuery]);
  return { archive: query.data, isLoading: query.isLoading, error: query.error ?? undefined, refetch };
}
